import {useHistory} from "react-router-dom";
import {useRouteMatch} from "react-router";
import React, {useEffect, useState} from "react";
import {useOrdenesCompraService} from "services/hooks";
import {useSnackbar} from "notistack";
import {CardOrdenCompra} from "components/picking/IngresoMercaderia/card.ordenCompra";
import {CardHeader} from "components/picking/components/card.header";
import Typography from "@material-ui/core/Typography";

export function SelectOrdenCompraView() {
    const [ordenes, setOrdenes] = useState([]);

    const history = useHistory();
    const match = useRouteMatch();
    const {enqueueSnackbar} = useSnackbar();
    const OrdenesCompraService = useOrdenesCompraService();

    useEffect(() => {
        OrdenesCompraService.getAll(
            response => setOrdenes(response.data.result),
            error => enqueueSnackbar(error, {variant: 'error'})
        );
    }, []);

    const navToScan = id => {
        history.push(`${match.url}/${id}`);
    }

    return (
        <div>
            <CardHeader
                backUrl={'/picking'}
                textLeft={'Ingreso de Mercadería'}
                textRight={ordenes.length + ' órdenes'}
            />
            {ordenes.length <= 0 && (
                <Typography variant="body1" align={"center"} className={"mt-4"}>No hay órdenes de compra pendientes de ingreso</Typography>
            )}
            {ordenes.map((orden, index) =>
                <CardOrdenCompra
                    key={index}
                    id={orden.id}
                    proveedor={orden.proveedor_apodo || orden.proveedor_nombre || orden.proveedor}
                    fecha={orden.fecha}
                    onClick={() => navToScan(orden.id)}
                />
            )}
        </div>
    )
}
